import React from "react";
import * as styles from "./Details.module.scss";

const Details = ({ details }) => {
  const formattedDetails = details?.replace(/&lt;br\/&gt;/g, "<br/>");

  function createMarkup() {
    return { __html: formattedDetails };
  }

  return (
    <div className={styles.details__container}>
      <div className={styles.title}>
        <h3>Detalles</h3>
      </div>
      <div className={styles.details}>
        <div dangerouslySetInnerHTML={createMarkup()} />
        <ul>
          <il></il>
        </ul>
      </div>
    </div>
  );
};

export default Details;
